import { TEnumerationType } from "./type";

export type TGranularityKey = 'daily' | 'weekly' | 'monthly';
export type TGranularityValue = 'daily' | 'weekly' | 'monthly';

export interface IGranularityProp {
  // 自身的key
  key: TGranularityKey;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: TGranularityValue;
  enumType: TEnumerationType;
};

export type IGranularity = Record<TGranularityKey, IGranularityProp>

export const GRANULARITY: IGranularity = {
  daily: {
    label: 'Daily',
    labelKey: 'dbi_daily',
    value: 'daily',
    key: 'daily',
    enumType: 'granularity',
  },
  weekly: {
    label: 'Weekly',
    labelKey: 'dbi_weekly',
    value: 'weekly',
    key: 'weekly',
    enumType: 'granularity',
  },
  monthly: {
    label: 'Monthly',
    labelKey: 'dbi_monthly',
    value: 'monthly',
    key: 'monthly',
    enumType: 'granularity',
  },
};